import React from 'react';
import PropTypes from 'prop-types';

import StyledBaseFab from './Fab.style';
import { ENTER } from '../../utils/keyCodes';

const Fab = ({ type, children, onClick, disabled }) => (
  <StyledBaseFab
    role="button"
    type={type}
    onClick={onClick}
    onKeyDown={(e) => e.keyCode === ENTER && onClick(e)}
    aria-label="Fab"
    disabled={disabled}
  >
    {children}
  </StyledBaseFab>
);

Fab.defaultProps = {
  type: 'secondary',
  children: [],
  onClick: undefined,
  disabled: false,
};

Fab.propTypes = {
  type: PropTypes.oneOf(['primary', 'secondary']),
  children: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default React.memo(Fab);
